"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var image_1 = __importDefault(require("next/image"));
var link_1 = __importDefault(require("next/link"));
var react_1 = __importStar(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var ProfileMenuListItem = function (_a) {
    var disabled = _a.disabled, onClick = _a.onClick, icon = _a.icon, label = _a.label, dropdown = _a.dropdown, balance = _a.balance, href = _a.href, alt = _a.alt, button = _a.button, secondary = _a.secondary, labelComponent = _a.labelComponent, onlyIconClick = _a.onlyIconClick;
    var _b = (0, react_1.useState)(false), isOpen = _b[0], setIsOpen = _b[1];
    var handleClick = (0, react_1.useCallback)(function () {
        if (!disabled) {
            onClick ? onClick() : setIsOpen(!isOpen);
        }
    }, [disabled, isOpen, onClick]);
    var imageAlt = (0, react_1.useMemo)(function () { return (label ? label : alt ? alt : ''); }, [alt, label]);
    var is100PercentsWidth = (0, react_1.useMemo)(function () { return !!labelComponent; }, [labelComponent]);
    return (react_1.default.createElement("li", { className: "".concat(styles_module_scss_1.default.listItem, " ").concat(disabled ? styles_module_scss_1.default.grey : '', " ").concat(is100PercentsWidth ? styles_module_scss_1.default.fullWidth : '') },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.labels, onClick: handleClick },
            href ? (react_1.default.createElement(link_1.default, { href: href },
                react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.menuItemContainer, " menuItemContainer") },
                    react_1.default.createElement("img", { className: styles_module_scss_1.default.listItemIcon, src: icon, alt: imageAlt, onClick: function () {
                            onlyIconClick && onlyIconClick();
                        } }),
                    react_1.default.createElement("span", { className: "".concat(styles_module_scss_1.default.itemLink, " ").concat(secondary ? styles_module_scss_1.default.secondary : '') }, label)))) : (react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.menuItemContainer, " menuItemContainer") },
                react_1.default.createElement("img", { className: styles_module_scss_1.default.listItemIcon, src: icon, alt: imageAlt, onClick: function () {
                        onlyIconClick && onlyIconClick();
                    } }),
                label ? (react_1.default.createElement("span", { className: "".concat(styles_module_scss_1.default.itemLink, " ").concat(secondary ? styles_module_scss_1.default.secondary : '') }, label)) : (labelComponent))),
            balance || dropdown ? (react_1.default.createElement("div", { style: { position: 'relative' } },
                balance ? react_1.default.createElement("span", null,
                    " ",
                    balance,
                    " ") : null,
                dropdown ? (react_1.default.createElement("span", null,
                    react_1.default.createElement(image_1.default, { width: 14, height: 13, className: "".concat(styles_module_scss_1.default.arrow, " ").concat(isOpen ? styles_module_scss_1.default.selected : ''), onClick: handleClick, src: "/img/profileMenu/arrow.svg", alt: "arrow" }))) : null)) : null),
        isOpen && dropdown ? (react_1.default.createElement("div", { className: styles_module_scss_1.default.dropdownItem },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.dropdownBlock }, dropdown))) : null,
        button));
};
exports.default = ProfileMenuListItem;
